import { render, staticRenderFns } from "./ServiceVue.vue?vue&type=template&id=01475249"
import script from "./ServiceVue.vue?vue&type=script&lang=js"
export * from "./ServiceVue.vue?vue&type=script&lang=js"
import style0 from "./ServiceVue.vue?vue&type=style&index=0&id=01475249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports